// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
function use(hasProducts) {
  var match = ViewportContext$Showside.use(undefined);
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var route = match$1.route;
  var productId;
  productId = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.productId;
  var panelClosed;
  panelClosed = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.panelClosed;
  if (match.isMobile || Caml_obj.equal(panelClosed, true) || !hasProducts) {
    return 0;
  } else if (productId === undefined) {
    return 375;
  } else {
    return 750;
  }
}
export { use };
/* RouterProvider-Showside Not a pure module */